import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TruckLoadingType } from '../../store/state/administration/hub/constants/hub.constant';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../decorators';

@AutoUnsubscribe
@Pipe({
    name: 'truckLoadingType', pure: false,
    standalone: false
})
export class TruckLoadingTypePipe implements PipeTransform {
  private langChangeSubscription: Subscription;

  subscriptions: Subscription[] = [];

  constructor(private translateService: TranslateService, private cdr: ChangeDetectorRef) {
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.cdr.markForCheck();
    });
    this.subscriptions.push(this.langChangeSubscription);
  }

  transform(value: TruckLoadingType | TruckLoadingType[], isFullTranslate: boolean = true): string {
    if (!value) {
      return '';
    }

    const translateKey = (type: TruckLoadingType): string =>
      isFullTranslate
        ? `monitoring.uli.create.truckInfo.truckLoadingTypes.${type}`
        : `administration.dock.overview.${type.toLocaleLowerCase()}`;

    return Array.isArray(value)
      ? value.map((type: TruckLoadingType) => this.translateService.instant(translateKey(type))).join(',\r\n')
      : this.translateService.instant(translateKey(value));
  }
}
